module.exports = __webpack_public_path__ + "img/TitleIcon.e1dd4a8f.svg";